<template>
	<div class="app">
		<Card dis-hover>
			<div class="page-body">
				<Form ref="queryForm" :label-width="100" label-position="right" inline>
					<Row :gutter="20">
						<Col span="5">
						<FormItem label="客户简名：" style="width: 100%">
							<Select v-model="params.customerJM" placeholder="">
								<Option value="">---</Option>
								<Option v-for="(item, index) in customerJMList" :value="item.value" :key="index">
									{{ item.name }}
								</Option>
							</Select>
						</FormItem>
						</Col>
						<Col span="5">
						<FormItem label="计划开始时间:" style="width: 100%">
							<DatePicker v-model="params.planStartTime" type="daterange" @on-change="dateChangeStart"
								placement="bottom-end" placeholder="请选择"></DatePicker>
						</FormItem>
						</Col>
						<Col span="5">
						<FormItem label="计划结束时间:" style="width: 100%">
							<DatePicker v-model="params.planEndTime" type="daterange" @on-change="dateChangeEnd"
								placement="bottom-end" placeholder="请选择"></DatePicker>
						</FormItem>
						</Col>
						<Col span="5">
						<FormItem label="被访人:" :label-width="60" style="width: 100%">
							<Input v-model="params.visitedPerson" placeholder=""></Input>
							<!-- <Cascader :data="cities" v-model="params.city"></Cascader> -->
						</FormItem>
						</Col>
						<Col span="5">
						<FormItem label="走访人:" :label-width="100" style="width: 100%">
							<Input v-model="params.visitingPerson" placeholder=""></Input>
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Button icon="ios-search" type="primary" size="default" @click="queryTab"
							class="toolbar-btn">查询</Button>
						<!-- <Button @click="addSupper" icon="md-add" type="primary" size="default" class="toolbar-btn">添加</Button> -->
						<Button @click="addSupperRow" icon="md-add" type="primary" size="default"
							class="toolbar-btn">添加</Button>
						<Button icon="md-archive" type="primary" size="default" @click="downLoadTemplate"
							class="toolbar-btn">下载导入模板</Button>
						<Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile"
							:headers="requestHeader" accept=".xlsx,.xls,.excel" :show-upload-list="false"
							:action="action" :data="importData">
							<Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入数据</Button>
						</Upload>
						<Button type="success" icon="md-archive" @click="exportFile" class="toolbar-btn">导出</Button>
						<Button type="success" icon="md-archive" @click="exportFileChat"
							class="toolbar-btn">导出甘特图</Button>
					</Row>
					<br>
				</Form>
				<div v-if="list">
					<!-- ? TableRowAdd  Form嵌套住整个表格 使用行内规则-->
					<Form ref="formAddSupperRowObj" :model="addSupperRowObj" :label-width="10">
						<Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list">
							<!-- 数据 -->
							<!-- ? TableRowAdd 插槽内每个都需要单独判断 -->
							<!-- 计划开始时间 -->
							<template slot-scope="{ row, index }" slot="planStartTimeText">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="planStartTimeText"
										:rules="{required: true, message: '请输入', trigger: 'blur',type:'date'}">
										<DatePicker type="datetime" placeholder="请选择" :transfer="true"
											v-model="addSupperRowObj.planStartTimeText"></DatePicker>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.planStartTimeText }}
								</div>
							</template>

							<!-- 计划时间 -->
							<template slot-scope="{ row, index }" slot="planEndTimeText">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="planEndTimeText"
										:rules="{required: true, message: '请输入', trigger: 'blur',type:'date'}">
										<DatePicker type="datetime" placeholder="请选择" :transfer="true"
											v-model="addSupperRowObj.planEndTimeText"></DatePicker>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.planEndTimeText }}
								</div>
							</template>

							<!-- 客户简名  -->
							<template slot-scope="{ row, index }" slot="customerJM">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="customerJM"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<!-- ? TableRowAdd  :transfer="true"使下拉弹窗不受父级影响 -->
										<Select v-model="addSupperRowObj.customerJM" :transfer="true" placeholder="请选择">
											<Option value="">---</Option>
											<Option v-for="(item, index) in customerJMList" :value="item.value"
												:key="index">
												{{ item.name }}
											</Option>
										</Select>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.customerJM }}
								</div>
							</template>

							<!-- 被访人 -->
							<template slot-scope="{ row, index }" slot="visitedPerson">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="visitedPerson"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<Input v-model="addSupperRowObj.visitedPerson" placeholder="请输入"></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.visitedPerson }}
								</div>
							</template>
							<!-- 目的 -->
							<template slot-scope="{ row, index }" slot="purpose">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="purpose" :rules="{required: true, message: '请输入', trigger: 'blur'}">
										<Input v-model="addSupperRowObj.purpose" placeholder="请输入"></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.purpose }}
								</div>
							</template>
							<!-- 计划明细 -->
							<template slot-scope="{ row, index }" slot="planDetails">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="planDetails"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<Input v-model="addSupperRowObj.planDetails" placeholder="请输入"></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.planDetails }}
								</div>
							</template>
							<!-- 走访人 -->
							<template slot-scope="{ row, index }" slot="visitingPerson">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="visitingPerson"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<Input v-model="addSupperRowObj.visitingPerson" placeholder="请输入"></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.visitingPerson }}
								</div>
							</template>
							<!-- 操作按钮 -->
							<template slot-scope="{ row, index }" slot="action">
								<!-- ? TableRowAdd 最好使用插槽模式不要用render  columns下slot属性-->
								<!-- ? TableRowAdd 判断状态是否是新增add或者编辑edit -->
								<template v-if="row.actionType == 'add' || row.actionType == 'edit'">
									<Button type="primary" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="saveSupperRow(row)">保存</Button>
									<Button size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="cancelSupperRow(row,index)">取消</Button>
								</template>
								<template v-else>
									<!-- ? TableRowAdd 当前行不为特殊状态时才显示以下操作-->
									<!-- <Button type="primary" size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px" @click="() => { itemId = row.id; isAdd = '编辑'; createShow = true; }">编辑</Button> -->
									<Button type="primary" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="showLog(row,index)">操作日志</Button>
									<Button type="primary" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="editSupperRow(row,index)">编辑</Button>
									<Button type="error" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="delCustomer(row)">删除</Button>
								</template>
							</template>
						</Table>
					</Form>
					<Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10"
						@on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="params.MaxResultCount"
						:current="currentPage"></Page>
				</div>
			</div>
		</Card>
		<Spin class="spin" fix v-if="spinShow" size="large">导入中...</Spin>
		<NewCustomer :value="createShow" :isAdd="isAdd" @close="close" :id="itemId" @getTab="getTab"
			:customerJMList="customerJMList" />
			
		<Modal title="操作日志" :value="logShow" @on-ok="close()" @on-cancel="close" :mask-closable="false" width="600">
			 <div class="project">
			     <!-- 操作日志 -->
			       <Timeline>
			         <TimelineItem v-for="(log,index) in form.businessLogList" :key="index">
			           <p class="time">{{log.creatorName}}<span style="margin-left:10px;color:#b6b6b6;">{{log.creationTimeText}}</span></p>
			           <p class="content">{{log.content}}</p>
			         </TimelineItem>
			       </Timeline>
			 </div>
			 <Spin size="large" fix v-show="spinShow"></Spin>
		</Modal>
	</div>
</template>

<script>
	import Util from '../../lib/util'
	import moment from 'moment'
	import NewCustomer from './editCustomerInterviewPlan.vue'
	import {
		city
	} from '../../lib/city'
	import {
		getCustomerInterviewPlanList,
		removeCustomerInterviewPlan
	} from '../../api/index'
	import expandTable from './table-expand.vue'
	import {
		number
	} from 'echarts'
	import {
		createCustomerInterviewPlan,
		updateCustomerInterviewPlan,
		getCustomerInterviewPlanById,
		getCustomerInterviewPlanDetailInfoById
	} from '../../api/index'
	export default {
		name: 'customerInterviewPlanODM',
		data() {
			return {
				list: [],
				itemId: 0,
				params: {
					planStartTime: [],
					planEndTime: [],
					visitedPerson: '',
					visitingPerson: '',
					planStartTimeStart: '',
					planStartTimeEnd: '',
					planEndTimeStart: '',
					planEndTimeEnd: '',
					departmentType: this.$constDefinition.ODM事业部,
					SkipCount: 0,
					MaxResultCount: 10,
				},
				requestHeader: {
					Authorization: `Bearer ${Util.abp.auth.getToken()}`,
				},
				importData: {
					departmentType: this.$constDefinition.ODM事业部,
				},
				action: this.$constDefinition.baseUrl + `/Customerfile/Upload?departmentType=${this.$constDefinition.ODM事业部}`,
				totalCount: 0,
				currentPage: 1,
				loading: false,
				form:[],
				logShow:false,
				createShow: false,
				testDate: false,
				spinShow: false,
				quotationModelShow: false,
				contractModelShow: false,
				settlementModelShow: false,
				afterSalesModelShow: false,
				isAdd: '',
				columns: [],
				cities: city,
				userData: [],
				customerJMList: [],
				enterpriseNatureData: [],
				addSupperRowObj: {
					// ? TableRowAdd 添加、编辑时的数据缓存
					customerId: 0,
					planStartTimeText: '',
					planEndTimeText: '',
					customerJM: '',
					visitedPerson: '',
					purpose: '',
					planDetails: '',
					visitingPerson: '',
					actionType: '',
				},
			}
		},
		components: {
			NewCustomer,
		},
		mounted() {
			this.getColumns()
			this.getTab()
		},
		created() {
			this.getSelectList()
		},
		methods: {
			//获取表格数据
			async getTab(row) {
				// 客户管理页面
				// 获取客户信息
				const data = await getCustomerInterviewPlanList(this.params)
				this.list = data.data.result.items
				this.totalCount = data.data.result.totalCount
			},
			//   获取下拉框数据
			async getSelectList() {
				const {
					data
				} = await this.$Ajax.get(
					`/api/services/app/CustomerInterviewPlanApiService/GetInitInterviewPlanMgrInitData?departmentType=`+this.$constDefinition.ODM事业部
				)
				this.customerJMList = data.result.customerJMData
				console.log(this.customerJMList)
			},
			//查询
			queryTab() {
				this.params.SkipCount = 0
				this.currentPage = 1
				this.$nextTick(() => {})
				this.getTab()
			},
			addSupper() {
				this.isAdd = '添加'
				this.createShow = true
			},
			// ? TableRowAdd 判断是否处于编辑状态
			isModeEdit(row) {
				if (row.actionType == 'add' || row.actionType == 'edit') {
					return true
				} else {
					return false
				}
			},
			// ? TableRowAdd 添加 添加一行
			addSupperRow() {
				// 判断是否有正处于编辑状态的数据
				if (
					this.list.some((item) => {
						return item.actionType === 'edit' || item.actionType === 'add'
					})
				) {
					//有正处于编辑状态的数据
					this.$Message.error({
						content: '请先保存添加的数据',
						duration: 3,
					})
					return
				}
				this.clearSupperObj() //重置一下添加
				this.addSupperRowObj.actionType = 'add' //操作状态 添加add 编辑edit
				this.addSupperRowObj.departmentType = this.$constDefinition.ODM事业部
				this.list.unshift(this.addSupperRowObj) //在数据最前面添加一行空行
			},
			editSupperRow(row, index) {
				// 判断是否有正处于编辑状态的数据
				//判断是否处于编辑状态
				if (
					this.list.some((item) => {
						return item.actionType === 'edit' || item.actionType === 'add'
					})
				) {
					//有正处于编辑状态的数据
					this.$Message.error({
						content: '请先保存添加的数据',
						duration: 3,
					})
					return
				}
				this.$set(this.list[index], 'actionType', 'edit') //通过下标使用set方法加上操作状态 添加add 编辑edit
				let data = JSON.parse(JSON.stringify(row)) //转换一下使两份数据不指向同一内存地址(深拷贝)
				data.planStartTimeText = new Date(row.planStartTime)
				data.planEndTimeText = new Date(row.planEndTime)
				this.addSupperRowObj = data //编辑时把数据存起来
			},
			// ? TableRowAdd 取消添加/更改
			cancelSupperRow(row, index) {
				// 判断是添加还是编辑
				if (row.actionType == 'add') {
					//添加时直接删除
					this.list.shift() //在数据最前面删除一行
				} else {
					//编辑时还原数据
					this.$set(this.list[index], 'actionType', '') //还原操作状态
				}
				this.clearSupperObj()
			},
			// ? TableRowAdd 添加编辑保存
			saveSupperRow(row) {
				// formAddSupperRowObj确保不要有同样的ref否则$refs找不到
				this.$refs['formAddSupperRowObj'].validate(async (valid) => {
					if (valid) {
						// 转换一下数据 把带时区的时间格式转换成无时区的时间格式
						this.addSupperRowObj.planStartTime = this.$moment(this.addSupperRowObj
							.planStartTimeText).format(
							'YYYY-MM-DD HH:mm:ss'
						)

						// 转换一下数据 把带时区的时间格式转换成无时区的时间格式
						this.addSupperRowObj.planEndTime = this.$moment(this.addSupperRowObj.planEndTimeText)
							.format(
								'YYYY-MM-DD HH:mm:ss'
							)
						// 判断是添加还是编辑
						if (row.actionType == 'add') {
							//添加时
							try {
								const data = await createCustomerInterviewPlan(this.addSupperRowObj)
								if (data.data.success) {
									this.$Message.success('添加成功')
									this.getTab()
								} else {
									this.$Message.error('添加失败')
								}
							} catch (error) {
								this.$Message.error('添加失败')
							}
						} else {
							//编辑时
							try {
								const data = await updateCustomerInterviewPlan(this.addSupperRowObj)
								if (data.data.success) {
									this.$Message.success('编辑成功')
									this.getTab()
								} else {
									this.$Message.error('编辑失败')
								}
							} catch (error) {
								this.$Message.error('编辑失败')
							}
						}
					} else {
						this.$Message.error('请按要求输入信息！')
					}
				})
			},

			// ? TableRowAdd 清空缓存数据
			clearSupperObj() {
				this.addSupperRowObj = {
					customerId: 0,
					planStartTimeText: '',
					planEndTimeText: '',
					customerJM: '',
					visitedPerson: '',
					purpose: '',
					planDetails: '',
					visitingPerson: '',
					actionType: '',
				}
			},
			//分页
			pageChange(size) {
				this.params.SkipCount = (size - 1) * this.params.MaxResultCount
				this.getTab()
			},
			pagesizeChange(size) {
				this.params.MaxResultCount = size
				this.getTab()
			},
			//关闭弹框
			close() {
				this.createShow = false
				this.testDate = false
				this.logShow=false
			},
			//表格
			getColumns() {
				// ? TableRowAdd 改插槽模式 slot: 'action',与table元素下slot保持一致
				let _this = this
				this.columns = [{
						title: '计划开始日期',
						slot: 'planStartTimeText',
						width: 250,
					},
					{
						title: '计划结束日期',
						slot: 'planEndTimeText',
						width: 250,
					},
					{
						title: '客户简名',
						slot: 'customerJM',
					},
					{
						title: '被访人',
						slot: 'visitedPerson',
					},
					{
						title: '目的',
						slot: 'purpose',
					},
					{
						title: '计划明细',
						slot: 'planDetails',
					},
					{
						title: '走访人',
						slot: 'visitingPerson',
					},
					// ? TableRowAdd 改插槽模式 slot: 'action',与table元素下slot保持一致
					{
						title: '操作',
						align: 'left',
						width: 200,
						slot: 'action',
					},
				]
			},
			//删除
			delCustomer(row) {
				this.$Modal.confirm({
					title: '确定删除数据？',
					content: '删除后不可撤销',
					okText: '确认',
					cancelText: '取消',
					onOk: async () => {
						let res = await removeCustomerInterviewPlan(row.id)
						if (res.data.success) {
							this.$Message.success('删除成功')
						} else {
							this.$Message.success('删除失败')
						}
						this.getTab()
					},
				})
			},
			async showLog(row) {
			  this.logShow = true
			  const data = await getCustomerInterviewPlanDetailInfoById({ id: row.id })
			  this.form = { ...data.data.result }
			  console.log(this.form);
			  this.spinShow = false
			},
			//关闭弹框
			closeModel() {
				this.quotationModelShow = false
				this.contractModelShow = false
				this.settlementModelShow = false
				this.afterSalesModelShow = false
				this.getTab()
			},
			//时间改变
			dateChangeStart() {
				let time = this.params.planStartTime
				let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
				let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
				this.params.planStartTimeStart = start
				this.params.planStartTimeEnd = end
			},
			//时间改变
			dateChangeEnd() {
				let time = this.params.planEndTime
				let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
				let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
				this.params.planEndTimeStart = start
				this.params.planEndTimeEnd = end
			},
			// 导入前处理
			beforeImportFile() {
				this.spinShow = true
			},
			// 导入成功
			importFile() {
				this.$Message.success({
					content: '导入成功',
					duration: 3,
				})
				this.getTab()
				this.spinShow = false
			},
			// 导入失败
			errorImportFile(error, file, fileList) {
				this.$Message.error({
					content: file.error.message,
					duration: 3,
				})
				this.getTab()
				this.spinShow = false
			},
			// 下载导入模板
			downLoadTemplate() {
				this.downloadFile('/Customerfile/DownloadModel', '导入客户走访计划模板')
			},
			downloadFile(url, title) {
				const date = moment(new Date()).format('yyyyMMDDHHmm')
				let _this = this
				let consturl = this.$constDefinition.baseUrl + url //下载地址url
				var xhr = new XMLHttpRequest()
				xhr.open('get', consturl, true) // get、post都可
				xhr.responseType = 'blob'
				xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
				xhr.onload = function() {
					console.log(xhr)
					if (xhr.status == 200) {
						let blob = new Blob([this.response], {
							type: 'application/vnd.ms-excel',
						})
						var a = document.createElement('a')
						var url = window.URL.createObjectURL(blob)
						a.href = url
						a.download = title + date + '.xlsx' // 文件名
						if (xhr.readyState === 4) {
							_this.$Message.success({
								content: '下载成功',
								duration: 3,
							})
						}
					} else {
						_this.$Message.error({
							content: '下载失败',
							duration: 3,
						})
					}
					a.click()
					window.URL.revokeObjectURL(url)
				}
				xhr.send()
			},
			exportFile() {
				var _this = this

				this.$downLoad(
					'/api/Export/ExportCustomerInterviewPlan',
					'客户走访计划',
					'.xlsx',
					this.params
				)
			},
			exportFileChat() {
				var _this = this

				this.$downLoad(
					'/api/Export/ExportCustomerGantt',
					'客户走访计划甘特图',
					'.xlsx',
					this.params
				)
			},
		},
	}
</script>

<style scoped lang="less">
	.app {
		min-width: 1260px;
	}

	/deep/ .ivu-table-expanded-cell {
		padding: 0;
		padding-left: 50px;
	}

	/deep/.ivu-form-item {
		margin-bottom: 10px;
	}

	/deep/.ivu-form-item-error {
		margin-bottom: 20px;
	}

	.formItemArea {
		margin-top: 10px;
	}
</style>